import { BranchContainer } from '@/features/shared/components/BranchContainer'
import { RouteName } from '@shared/constants/routes'
import { createServerSidePropsHandler } from '@/features/shared/serverUtils/ssrHelpers/createServerSidePropsHandler'
import { withSimpleHeaderLayout } from '@/features/shared/components/Headers/Layouts/SimpleHeaderLayout'

export const getServerSideProps = createServerSidePropsHandler(RouteName.BRANCH_UNGATED)

export default withSimpleHeaderLayout(BranchContainer)
